<template>
  <div class="pc-list" ref="list">
    <NewCompetitionWorkSearch @search="search" />
    <div class="pc-head">
      <div
        class="pc-head-handle"
        style="display: flex; justify-content: space-between"
      >
        <div>
          <span>作品数量 {{ worksCount.works_count }}</span> &nbsp;
          <span>作品提交数量 {{ worksCount.submit_count }}</span> &nbsp;
          <span>作品未提交数量 {{ worksCount.un_submit_count }}</span>
        </div>
        <div style="display: flex; align-items: center">
          <div class="pc-head-btn">
            <button @click="addCompetitionWork">添加</button>
          </div>
          <p>{{ "共" + pagination_options.total + "条" }}</p>
        </div>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="competitionWorkList"
    >
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="competitionWorkList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="works_code"
        sortable="custom"
        label="竞赛ID"
        width="160"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.works_code ? scope.row.works_code : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="封面图" width="100" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.cover_image" :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_name"
        label="名称"
        width="120"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.chinese_name
                ? scope.row.chinese_name
                : scope.row.english_name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="award1" label="奖项一" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.award1 ? scope.row.award1 : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="award2" label="奖项二" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.award2 ? scope.row.award2 : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="award3" label="奖项三" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.award3 ? scope.row.award3 : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="预审核" prop="pre_audit" width="90">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pre_audit"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" prop="submitTime" width="120">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.submit_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="180">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
    </el-table>
    <DeleteHint :dialogVisible="deleteDialogVisible" @cancel="closeDelete" />
    <Pagination
      v-if="competitionWorkList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import NewCompetitionWorkSearch from "./NewCompetitionWorkSearch";
import DeleteHint from "@/components/template/DeleteHint";
import {
  competitionWorkList_Api,
  updateCompetitionWorkDetail_Api,
  competitionWorkDetail_Api,
  competitionWorksCount_Api,
} from "@/apis/competition.api";
export default {
  components: {
    NewCompetitionWorkSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "+works_code",
        competition_id: null,
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      isSelectAll: false,
      competitionWorkList: [],
      checked: [],
      worksCount: {},
    };
  },
  mounted() {
    this.getCompetitionWorkListByRules(this.searchRules);
    competitionWorksCount_Api(+this.$route.query.id).then((res) => {
      this.worksCount = res.data;
      console.log(res);
    });
  },
  methods: {
    // 获取
    getCompetitionWorkListByRules(data) {
      this.loading = true;
      this.searchRules.competition_id = +this.$route.query.id;
      competitionWorkList_Api(data)
        .then((res) => {
          console.log(res.data);
          this.$set(this.pagination_options, "total", res.count);
          res.data.forEach((el) => {
            el.isSelect = false;
          });
          this.competitionWorkList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    addCompetitionWork() {
      let route = this.$router.resolve({
        path: `/admin/newCompetitionWorkDetail?competition_id=${this.$route.query.id}`,
        query: { competition_id: this.$route.query.id, method: "add" },
      });
      window.open(route.href, "_blank");
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.checked = [];
        this.competitionWorkList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.competitionWorkList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
        console.log(this.searchRules.order);
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "+works_code";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionWorkListByRules(data);
      this.pagination_options.page = 1;
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/newCompetitionWorkDetail",
        query: {
          competition_id: this.$route.query.id,
          id: item.id,
          method: "update",
        },
        name: "newCompetitionWorkDetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },

    // 修改状态
    changeState(row) {
      updateCompetitionWorkDetail_Api({
        works_id: row.id,
        pre_audit: row.pre_audit,
      })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getCompetitionWorkListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      // if (!formData.competition_id) {
      data.competition_id = +this.$route.query.id;
      // }
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.pre_audit) {
        data.pre_audit = parseInt(formData.pre_audit);
      }
      if (formData.name_keywords) {
        data.name_keywords = formData.name_keywords;
      }
      if (formData.works_code) {
        data.works_code = formData.works_code;
      }
      if (formData.submit) {
        data.submit = formData.submit;
      }
      return data;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    //导出数据

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionWorkListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/NewCompetitionWorkTable.vue